<template>
  <label class="ds-input-text">
    <span v-if="label" class="ds-input-text__label">{{ label }}</span>
    <input
      class="ds-input-text__field"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :name="name"
      :autocomplete="autocomplete"
      @input="onInput"
    >
  </label>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  label?: string
  modelValue?: string
  placeholder?: string
  type?: string
  name?: string
  autocomplete?: string
  disabled?: boolean
}>(), {
  label: undefined,
  modelValue: '',
  placeholder: '',
  type: 'text',
  name: '',
  autocomplete: 'off',
  disabled: false
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}
</script>

<style scoped>
.ds-input-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ds-input-text__label {
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-base);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  gap: 24px;
  padding: 8px 0;
}

.ds-input-text__field {
  width: 100%;
  min-height: 48px;
  box-sizing: border-box;
  border: 1px solid #A9AEB5;
  border-radius: 4px;
  background: #FFFFFF;
  padding: 5px 12px;
  color: var(--ds-text-primary, #1F1F1F);
  font-family: var(--ds-font-family-base);
  font-size: 16px;
  line-height: 1.2;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.ds-input-text__field::placeholder {
  color: #9EA2A8;
}

.ds-input-text__field:hover {
  border-color: var(--ds-purple-main);
}

.ds-input-text__field:focus {
  border-color: var(--ds-purple-main);
  box-shadow: 0 0 0 3px rgba(109, 89, 234, 0.12);
}

.ds-input-text__field:disabled {
  background: #F4F5F7;
  cursor: not-allowed;
}
</style>
